/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionSheetController, AlertController, ModalController, Platform } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { LoadingController } from '@ionic/angular';
import { Observable, forkJoin } from 'rxjs';
import { ImagingService } from 'src/app/providers/files/imaging.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { environment } from 'src/environments/environment';
import { ImageModalPage } from 'src/app/components/image-modal/image-modal.page';
import { AccessService } from 'src/app/providers/access/access.service';


@UntilDestroy()
@Component({
  selector: 'app-basic',
  templateUrl: './basic.page.html',
  styleUrls: ['./basic.page.scss'],
})
export class BasicPage implements OnInit {
  charsAllowed = 500;
  charsUsed = 0;
  
  // eslint-disable-next-line @typescript-eslint/ban-types
  state$: Observable<object>;
  basicForm: FormGroup;
  imageUrl: string;
  imagesArray: any = [];
  pdfArray: any = [];
  user: any;
  unreadCount: any;
  imageCount: any;
  savedCount: any;
  currentSavedSubmission: any;
  data: any;
  returnedReason: any = [];
  img: any;
  filename: any;
  photos: any = [];
  imgRes: any;
  options: any;
  isMobile: boolean = false;
  thisVersion:string;
  //showSaveComments = false;
  imgBaseUrl = environment.imgBaseUrl;
  userPlatform:any;
  constructor(
    private platform: Platform,
    public formBuilder: FormBuilder,
    private apiService: ApiService,
    public actionSheetController: ActionSheetController,
    public router: Router,
    private storageService: StorageService,
    public alertController: AlertController,
    public route: ActivatedRoute,
    private fileService: ImagingService, 
    private readonly domSanitizer: DomSanitizer, 
    private loadingController: LoadingController,
    private appVersion: AppVersion, 
    private modalCtrl: ModalController,
    public accessService: AccessService,
  ) {
    platform.ready().then(() => {
      this.userPlatform = this.platform;
      //console.log(platform);
      if (this.platform.is('android')) {
          //console.log("running on Android device!");
          this.isMobile = true;
      }
      if (this.platform.is('ios')) {
          //console.log("running on iOS device!");
          this.isMobile = true;
      }
      if (this.platform.is('mobileweb')) {
          //console.log("running in a browser on mobile!");
          this.isMobile = false;
      }
      

  });
  this.appVersion.getVersionNumber().then((res)=>{
    this.thisVersion = res;
  });
    this.basicForm = this.formBuilder.group({
      images: [[], [Validators.required]],
      /* comments: ['', [Validators.maxLength(this.charsAllowed)]], */
      User: [''],
      type: ['basic'],
      editing: [''], 
      submissionid: [''],
      ispatient: [false], //this is a billing submission, not a patient addition or update
      version: this.thisVersion,  
      platform: this.userPlatform,
    });
    this.handleToken();

  }
  ngOnInit(): void {
    //console.log('Saved Submission is: '+this.currentSavedSubmission);
    this.updateLog('open_basic', 'Opened Basic Submission Page', this.currentSavedSubmission);

   /*  this.basicForm.controls.comments.valueChanges.pipe(untilDestroyed(this))
      .subscribe((nv: string) => {
        if (nv)
        {
          this.charsUsed = nv.length;
        }
      }); */
  }

  ionViewDidEnter() {
    //console.log('Saved Submission is: '+this.currentSavedSubmission);
  }

  updateLog(type, detail, submissionid)
  {
    const params = {     
      action_type: type,
      action_detail: detail,
      data_id: submissionid,
    }
    this.apiService.post('logActivity', params).subscribe(
      (res) => {
        //console.log('activity res: ',res);    
        if (res.error === false) {      
        }
      },
      (err) => { }
    );
  }
 /*  showUpdateCommentsButton() {
    this.showSaveComments = true;
  } */
  handleToken() {
    this.imageCount = 0;
    this.storageService
      .getObject('userInfo')
      .then((result) => {
        if (result != null) {
          this.user = result;
          this.basicForm.controls.User.setValue(this.user);
          this.basicForm.controls.version.setValue(this.thisVersion);
          this.getnotificationCount();
          this.checkSavedSubmissions();
        }
      })
      .catch((e) => {
        // Handle errors here
      });
  }


    

  toDataURL(url) {
    return new Promise((resolve, _) => {
      var xhr = new XMLHttpRequest();
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(xhr.response);
    });
    
  }
  
  

  pickImagesWeb() {
    this.accessService.resetLogoutTimer();
    FilePicker.pickFiles({ 
      multiple: true,
      types: ["image"]
    }).then( picked => {
      picked.files.forEach(image => {
        //console.log('Image: '+ image.path);
        
        this.convertBlobToBase64(image.blob).then( dataurl => {
          //console.log("dataURL?: "+image.path);
          
          var photofile = {            
            img: dataurl,
            fileType: 'image'
          }
          this.imagesArray.push(photofile);
          this.updateImageCount();  
        });
      });    
    });
  }

  pickImagesMobile() {
    this.accessService.resetLogoutTimer();
    FilePicker.pickFiles({ 
      multiple: true, 
      readData: true,
    }).then( picked => {
    picked.files.forEach(image => {
      //check file types for allowed..
      if (image.mimeType.toLowerCase().endsWith('png') || image.mimeType.toLowerCase().endsWith('jpg') || image.mimeType.toLowerCase().endsWith('jpeg'))
      {
        var photofile = {      
          name: image.name,       
          img: image.data, //this.renderPictureAsBase64(this.convertPathToWebPath(image.path)),
          fileType: 'image'
        }
        this.imagesArray.push(photofile);
        this.updateImageCount();  
      } 
      else if (image.mimeType.toLowerCase().endsWith('pdf'))
      {
        var photofile = {    
          name: image.name,         
          img: image.data, //this.renderPictureAsBase64(this.convertPathToWebPath(image.path)),
          fileType: 'pdf'
        }
        this.pdfArray.push(photofile);
        this.updateImageCount();  
      }       
    });
  });  
  }

  renderPictureAsBase64(image) {
    return 'data:image/jpeg;base64,' + btoa(decodeURI(encodeURIComponent(image)))
  }
  async createSubmission(): Promise<void> {
    this.accessService.resetLogoutTimer();
    //create submission
    await this.apiService.post('submission_new', this.basicForm.value).subscribe(
      (res) => {
        if (res.error === false) {
          //console.log(res.submissionid);
          this.currentSavedSubmission = res.submissionid;

          this.updateLog('create_basic', 'Created New Basic Submission', res.submissionid);
          this.basicForm.controls.editing = res.submissionid;
          this.basicForm.controls.submissionid = res.submissionid;
        }
      },
      (err) => { }
    );
  }

  async addImage(photofile)
  {
    //add image to submission (new backend API function)
    var submissionid = 0;
    var check_params = {
      isportal:'false',
      User: {
        username: this.user.username,
        password: this.user.password,
      },
    };  
    await this.apiService
      .post('data/check-saved-submissions', check_params)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.savedCount = res.data.saved_count;
            //console.log('saved',res.data);
            if (this.savedCount > 0)
            {
              submissionid = res.data.submissionid;
              //console.log('submission: ',res.data.submissionid);
              this.currentSavedSubmission = submissionid;
              this.updateLog('basic_check', 'Adding Photo Submission Check', this.currentSavedSubmission);
              this.basicForm.controls.editing = this.currentSavedSubmission;
              this.basicForm.controls.submissionid = this.currentSavedSubmission;
              this.getSubmissionInfo();
            }
          }
          if (submissionid == 0) //error adding image
            {
              this.presentFailedSubmissionAlert('There was a problem adding your image.  Submission ID was not detected.  Please contact Medbill App Support.');
            }
            else
            {
            var params;  
            params = {
              image: photofile,
              /* comments: this.basicForm.value.comments, */
              submissionid: this.currentSavedSubmission,
              User: {
                username: this.user.username,
                password: this.user.password,
              },
            };  
            // Show loading spinner
            let loading = null;
            var addmessage = 'Adding Image to Submission '+submissionid+'. Please wait...'
            this.loadingController.create({
              message: addmessage,
              spinner: "circles"
              // You can customize options here
            }).then((loadingInstance) => {
              loading = loadingInstance;
              loading.present();
              this.apiService.post('submission_add_image', params).subscribe(
                (res) => {
                  //console.log('image---');
                  //console.log(res);
                  if (res.error === false) {
                    if (res.filename) 
                    {

                      if (res.filename.toLowerCase().endsWith('pdf'))
                        {
                          var photofile = {            
                            name: res.name,
                            img: '../assets/img/attachment1.png',
                            imgId: res.imageid,
                            fileType: 'pdf'
                          }
                          
                          loading.dismiss();
            
                          this.pdfArray.push(photofile);
                          this.updateImageCount();
                        }
                        else
                        {
                          var photofile = {            
                            name: res.name,
                            img: this.imgBaseUrl + res.filename,
                            imgId: res.imageid,
                            fileType: 'image'
                          }
                          
                          loading.dismiss();
            
                          this.imagesArray.push(photofile);
                          this.updateImageCount(); 
                        }
                      
                      if (res.name != '')
                      {
                        this.updateLog('add_basic', 'Added ' + res.name + ' to submission', this.currentSavedSubmission);  
                        this.presentSuccessfulSubmissionAlert('Image Added','Image ' + res.name + ' added successfully.');                
                      } 
                      else
                      {
                        this.updateLog('add_basic', 'Added ' + res.filename + ' to submission', this.currentSavedSubmission);  
                        this.presentSuccessfulSubmissionAlert('Image Added','Image ' + res.filename + ' added successfully.');
                      }
                    }
                  }
                  else
                  {
                    this.presentFailedSubmissionAlert('There was a problem adding your image:<br><br>'+res.error.message);
                    loading.dismiss();
                  }
                },
                (err) => { 
                  //console.log('err');
                }
              );  
              
            });  
          }       
        },
        (err) => {
          //console.log(err);
        }
      );
         
  }

  async billFileGetPhoto() {
    this.accessService.resetLogoutTimer();
    this.updateLog('selectphoto_basic', 'Using camera for submission photo', this.currentSavedSubmission);  
    if (!this.currentSavedSubmission) 
    {
      await this.createSubmission();
      await this.fileService.getPhoto().then(
        file => {
            var photofile = {     
              name: '',       
              img: file,
              fileType: 'image'
            }
            //console.log('photocam: ',photofile);
            this.addImage(photofile);
        }      
      );
    }
    else
    {
      this.fileService.getPhoto().then(
        file => {
            var photofile = {     
              name: '',       
              img: file,
              fileType: 'image'
            }
            //console.log('photocam: ',photofile);
            this.addImage(photofile);
        }      
      );
    } 
    /* this.showSaveComments = false; */
  }

  async billFileSelectMultiple(filetype:string) {
    this.accessService.resetLogoutTimer();
    //same as in billfilegetphoto - need to add new submission in saved status and add files to that 
    if (!this.currentSavedSubmission) 
    {
      await this.createSubmission();
    }
    if (filetype == 'files')
    {
      this.updateLog('selectfiles_basic', 'Selecting files for submission', this.currentSavedSubmission);  
      FilePicker.pickFiles({ 
        multiple: true, 
        readData: true,
      }).then( picked => {
        picked.files.forEach(image => {
          //console.log('image: ',image);
          //check file types for allowed..
          if (image.mimeType.toLowerCase().endsWith('png') || image.mimeType.toLowerCase().endsWith('jpg') || image.mimeType.toLowerCase().endsWith('jpeg'))
          {
            var photofile = {            
              name: image.name,
              img: 'data:'+image.mimeType+';base64,'+image.data,
              fileType: 'image'
            }
            //console.log('photofile: ',photofile);
            this.addImage(photofile);
          } 
          else if (image.mimeType.toLowerCase().endsWith('pdf'))
          {
            var pdffile = {                  
              name: image.name,       
              img: 'data:'+image.mimeType+';base64,'+image.data,
              fileType: 'pdf'
            }
            //console.log('pdffile: ',pdffile);
            this.addImage(pdffile);
          }       
        });
      });
    }
    else
    {
      this.updateLog('selectimages_basic', 'Selecting images for submission', this.currentSavedSubmission);  
      FilePicker.pickImages({ 
        multiple: true, 
        readData: true,
      }).then( picked => {
        picked.files.forEach(image => {
          //console.log('image: ',image);
          //check file types for allowed..
          
          var photofile = {            
            name: image.name,
            img: 'data:'+image.mimeType+';base64,'+image.data,
            fileType: 'image'
          }
          //console.log('photofile: ',photofile);
          this.addImage(photofile);
             
        });
      });
    }  
    /* this.showSaveComments = false; */    
  }

  public convertPathToWebPath(path: string): SafeUrl {
    const fileSrc = Capacitor.convertFileSrc(path);
    return this.domSanitizer.bypassSecurityTrustUrl(fileSrc);
  }
  
  blobToDataURL(blob: Blob): Promise<string> {
    
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = _e => resolve(reader.result as string);
      reader.onerror = _e => reject(reader.error);
      reader.onabort = _e => reject(new Error("Read aborted"));      
      reader.readAsDataURL(blob);
    });
  }

  blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  convertBlobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
        resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  updateImageCount() {
    var imagecounter = this.imagesArray.length;
    var pdfcounter = this.pdfArray.length; 
    this.imageCount = imagecounter + pdfcounter;
  }

  async presentSuccessfulSubmissionAlert(alertheader, alertmsg) {
    if (!alertheader)
    {
      alertheader = 'Submission Successful';
    }
    const alert = await this.alertController.create({
      cssClass: 'success_alert', 
      header: alertheader,
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }

  async presentFailedSubmissionAlert(alertmsg) {
    const alert = await this.alertController.create({
      cssClass: 'fail_alert', 
      header: 'Submission Failed',
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }

  getSubmissionInfo() {
    this.accessService.resetLogoutTimer();
    var params;  
    params = {
      action: '',
      submission_id: this.currentSavedSubmission,
    };  

  this.apiService.post('data/getSubmission', params).subscribe(
    (res) => {
      this.imagesArray=[];
      this.pdfArray=[];
      //console.log(res);
      if (res.error === false) {
        /* this.basicForm.controls.comments.setValue(res.data.Data.comments); */
      
        let pages = res.data.Page;
        pages.forEach(page => {
          //console.log('page: ',page);
          //console.log(this.imgBaseUrl + page.filename);
          if (page.filename) 
          {
            var filetype = 'image';
            var theimg = this.imgBaseUrl + page.filename;
            if (page.filename.toLowerCase().endsWith('pdf'))
            {
              filetype = 'pdf';
              theimg = '../assets/img/attachment1.png';
              var photofile = {   
                name: page.originalname,         
                img: theimg,
                imgId: page.id,
                fileType: filetype
              }            
              this.pdfArray.push(photofile);
            }
            else
            {

              var photofile = {   
                name: page.originalname,         
                img: theimg,
                imgId: page.id,
                fileType: filetype
              }            
              this.imagesArray.push(photofile);
            }
            this.updateImageCount();
          }
        });       
               
      }
    },
    (err) => {
    }
  );
  }

  /* async updateComments() {
    this.accessService.resetLogoutTimer();
    if (!this.currentSavedSubmission)
    {
      await this.createSubmission();
      this.presentSuccessfulSubmissionAlert('Updated Successfully','Comments updated successfully.');
    }
    else
    {
      await this.updateTheComments();
    }
  } */

  /* async updateTheComments()
  {
    //console.log(this.currentSavedSubmission);
    var params;  
    params = {
      comments: this.basicForm.value.comments,
      submissionid: this.currentSavedSubmission,
      User: {
        username: this.user.username,
        password: this.user.password,
      },
    };  
    // Show loading spinner
    let loading = null;
    this.loadingController.create({
      message: 'Please wait while we update your submission.',
      spinner: "circles"
      // You can customize options here
    }).then((loadingInstance) => {
      loading = loadingInstance;
      loading.present();
      this.apiService.post('submission_update_comments', params).subscribe(
        (res) => {
          //console.log(res);
          if (res.error === false) {
            loading.dismiss();
            this.updateLog('comments_basic', 'Comments updated', this.currentSavedSubmission);  
            this.presentSuccessfulSubmissionAlert('Updated Successfully','Comments updated successfully.');
            this.showSaveComments = false;
          }
          else
          {
            loading.dismiss();
            this.presentFailedSubmissionAlert('There was a problem updating your submission comments:<br><br>'+res.error.message);
          }
        },
        (err) => { 
          loading.dismiss();
          this.presentFailedSubmissionAlert('There was a problem with your submission.');
        }    
      );
    });
  } */

  submitBilling(comments) {
    this.accessService.resetLogoutTimer();

    //change the status of the submission to ready as we would already have a saved status submission
    
    var params;  
    params = {
      comments: comments,//this.basicForm.value.comments,
      submissionid: this.currentSavedSubmission,
      User: {
        username: this.user.username,
        password: this.user.password,
      },
    };  
    // Show loading spinner
    let loading = null;
    this.loadingController.create({
      message: 'Please wait while we submit your billing.',
      spinner: "circles"
      // You can customize options here
    }).then((loadingInstance) => {
      loading = loadingInstance;
      loading.present();
    
    this.apiService.post('submission_submit', params).subscribe(
      (res) => {
        if (res.error === false) {

          loading.dismiss();
          this.updateLog('submit_basic', 'Submitted '+res.pagecount+' images and or pdfs', this.currentSavedSubmission);  
          this.presentSuccessfulSubmissionAlert(null,'You have successfully submitted billing to Medbill. You will receive a confirmation email shortly.<br><br>Submission reference: '+res.submissionid+'<br>Billing Sheets: '+res.pagecount);
          this.router.navigateByUrl('/submission');  
        }
        else
        {
          loading.dismiss();
          this.presentFailedSubmissionAlert('There was a problem with your submission:<br><br>'+res.error.message);
          this.router.navigateByUrl('/home');
        }
      },
      (err) => { 
        loading.dismiss();
        this.presentFailedSubmissionAlert('There was a problem with your submission.');
        this.router.navigateByUrl('/home');
      }    
    );
  });
  }

  async submit() {   
    this.accessService.resetLogoutTimer(); 
    //final submission moved out of the update comments section below
    this.finalSubmission();

    //update any comments and then do the submission
    /* var params;  
    params = {
      comments: this.basicForm.value.comments,
      submissionid: this.currentSavedSubmission,
      User: {
        username: this.user.username,
        password: this.user.password,
      },
    }; 
    this.apiService.post('submission_update_comments', params).subscribe(
      (res) => {
        if (res.error === false) {
          this.finalSubmission();
        }
        
      },
      (err) => { }    
    );  */
    
  }
  async finalSubmission() {
    this.accessService.resetLogoutTimer();
    await this.getSubmissionInfo();
    var messagestring;
    //console.log('imagesarray: ',this.imagesArray, ', pdfarray: ',this.pdfArray);
    var imagesString;
    var pdfString;
    if (this.imagesArray.length == 1)
    {
      imagesString = '1 billing sheet image';
    }
    if (this.imagesArray.length > 1)
    {
      imagesString = this.imagesArray.length + ' billing sheet images';
    }
    if (this.pdfArray.length == 1)
    {
      pdfString = '1 billing sheet PDF';
    }
    if (this.pdfArray.length > 1)
    {
      pdfString = this.pdfArray.length + ' billing sheet PDFs';
    }
    if (this.imagesArray.length > 0)
    {
      messagestring = imagesString;
    }
    if (this.imagesArray.length > 0 && this.pdfArray.length > 0)
    {
      messagestring = messagestring + '<br>and<br>';
    }
    if (this.pdfArray.length > 0)
    {
      messagestring = messagestring + pdfString;
    }
      
    //console.log('messagestring: ',messagestring);
    if (this.imageCount > 0) {  
        const alert = await this.alertController.create({
          cssClass: 'confirmalert success_alert', 
          header: 'Please Confirm',
          mode:'ios',
          animated: true,
          inputs: [
            {
              name: 'comments',
              type: 'textarea',
              placeholder: 'Billing Submission Comments - keep brief - max 500 characters - read instructions before using comments',
              attributes: {
                maxlength: 500,
                rows:4,
              },
            },
          ],
          message: (this.imageCount==1?'Please check your billing sheet images before submitting!<br><br>Are you sure you want to submit<br><span class="yellow"><strong>'+messagestring+'</strong></span><br>with submission '+this.currentSavedSubmission+'?  Please note that you can attach more than one billing sheet and submit them together in one submission.':'Please check your billing sheet images before submitting!<br><br>Are you sure you want to submit<br><span class="yellow"><strong>'+messagestring+'</strong></span><br>with submission '+this.currentSavedSubmission+'?')+' <br><br>After you tap submit, please wait until you receive confirmation of a successful submission.<br><h6><strong>Submission Comments</strong></h6>',
          
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'red',
              handler: (blah) => {
              }
            }, {
              text: 'Submit',
              cssClass: 'buttonUpdate',
              handler: (alertData) => {
                this.submitBilling(alertData.comments);
              }
            } 
        
      ] });

      await alert.present();
    }
   else
   {
    this.presentAlertConfirm();
   }
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'missingAlert',
      header: 'Missing Billing Sheet',
      message: 'You must attach a Billing Sheet before you can Submit.',
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            //console.log('Confirm Cancel: blah');
          },
        },
       
      ],
    });

    await alert.present();
  }

  onRemoveImage(imageIndex) {
    this.accessService.resetLogoutTimer();
    //console.log(imageIndex);
    let Subject = 'Remove Billing Sheet?';
    let Message = 'Are you sure you want to remove this billing sheet image?<br><br><strong>This cannot be undone!</strong>';
    if (!imageIndex && imageIndex!=0)
    {
      //console.log('empty!');
      Subject = 'Remove ALL Billing Sheets?';
      Message = 'Are you sure you want to remove ALL billing sheet images?<br><br><strong>This cannot be undone!</strong>';
    }
    this.removeImageAlert('image',Subject,Message,imageIndex);
  }

  onRemovePDF(imageIndex) {
    this.accessService.resetLogoutTimer();
    //console.log(imageIndex);
    let Subject = 'Remove Billing Sheet?';
    let Message = 'Are you sure you want to remove this billing sheet PDF?<br><br><strong>This cannot be undone!</strong>';
    if (!imageIndex && imageIndex!=0)
    {
      //console.log('empty!');
      Subject = 'Remove ALL Billing Sheets?';
      Message = 'Are you sure you want to remove ALL billing sheet PDFs?<br><br><strong>This cannot be undone!</strong>';
    }
    this.removeImageAlert('pdf',Subject,Message,imageIndex);
  }

  async removeImageAlert(type,subject,message,imageIndex) {
    const alert = await this.alertController.create({
      cssClass: 'missingAlert centreAlert',
      header: subject,
      message: message,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          },
        },
        {
          text: 'Confirm',
          handler: () => {
            var params;  
            if (!imageIndex && imageIndex!=0)
            {
              //remove all images and pdfs from server and from pages table
              params = {
                removeall: true,
                isportal: false,
                submissionid: this.currentSavedSubmission,
                User: {
                  username: this.user.username,
                  password: this.user.password,
                },
              };  
              this.apiService.post('submission_del_image', params).subscribe(
                (res) => {
                  //console.log(res);
                  if (res.error === false) {
                    
                    this.imagesArray = [];
                    this.pdfArray = [];
                    var imagecount: number = +res.image;
                    this.updateImageCount();
                    if (imagecount > 1)
                    { 
                      
                      this.updateLog('delimage_basic', 'Removed '+imagecount+' Basic Submission Images and PDFs', this.currentSavedSubmission);                     
                      this.presentSuccessfulSubmissionAlert('Images cleared','Successfully removed '+imagecount+' billing sheet images and PDFs');

                    }
                    else
                    {
                      this.updateLog('delimage_basic', 'Removed 1 Basic Submission Image or PDF', this.currentSavedSubmission);  
                      this.presentSuccessfulSubmissionAlert('Images cleared','Successfully removed 1 billing sheet images or PDF');
                    }
                  }
                  else
                  {
                    this.presentFailedSubmissionAlert('There was a problem removing your billing sheets:<br><br>'+res.error.message);
                  }
                },
                (err) => { 
                  this.presentFailedSubmissionAlert('There was a problem removing your billing sheets.');
                }    
              );
            }
            else
            {
              //remove one image from server and from pages table 
              if (type=='image')
              {             
                params = {
                  imageid: this.imagesArray[imageIndex].imgId,
                  removeall: false,
                  submissionid: this.currentSavedSubmission,
                }; 
              }
              else
              {
                params = {
                  imageid: this.pdfArray[imageIndex].imgId,
                  removeall: false,
                  submissionid: this.currentSavedSubmission,
                }; 
            } 
              this.apiService.post('submission_del_image', params).subscribe(
                (res) => {
                  //console.log(res);
                  if (res.error === false) {
                    if (type=='image')
                    {
                      this.imagesArray.splice(imageIndex, 1);
                    }
                    else
                    {
                      this.pdfArray.splice(imageIndex, 1);
                    }
                    this.updateImageCount();
                  }
                  else
                  {
                    this.presentFailedSubmissionAlert('There was a problem removing your billing sheet:<br><br>'+res.error.message);
                  }
                },
                (err) => { 
                  this.presentFailedSubmissionAlert('There was a problem removing your billing sheet.');
                }    
              );
            }
          },
        },
      ],
    });

    await alert.present();
  }

  async cancel() {
    if (this.currentSavedSubmission)
    {

      this.updateLog('close_basic', 'Left Saved Basic Submission Page',this.currentSavedSubmission);
      const alert = await this.alertController.create({
        cssClass: 'missingAlert blueAlert centreAlert',
        header: "Leave Submission?",
        message: "You have not confirmed submission ID "+this.currentSavedSubmission+". Are you sure you want to return home?<br><br>The submission has been saved and you can return later to add or remove information before submitting.",
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
            },
          },
          {
            text: 'Resume Later',
            handler: () => {
              this.router.navigateByUrl('/home');
            }
          },
        ],
      });

      await alert.present();
    }
    else
    {
      this.router.navigateByUrl('/home');
    }
  }
  getnotificationCount() {
    const params = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      User: {
        username: this.user.username,
        password: this.user.password,
      },
    };
    this.apiService
      .post('user/get-unread-notification-count', params)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => { }
      );
  }

  checkSavedSubmissions() {
    this.accessService.resetLogoutTimer();
    var params = {
      isportal:'false',
      User: {
        username: this.user.username,
        password: this.user.password,
      },
    };  
    this.savedCount = 0;
    this.apiService
      .post('data/check-saved-submissions', params)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.savedCount = res.data.saved_count;
            if (this.savedCount > 0)
            {
              this.currentSavedSubmission = res.data.submissionid;
              this.updateLog('resume_basic', 'Resuming Basic Submission', this.currentSavedSubmission);
              this.basicForm.controls.editing = this.currentSavedSubmission;
              this.basicForm.controls.submissionid = this.currentSavedSubmission;
              this.getSubmissionInfo();
            }
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }  

  async openFullImage(imageIndex)
  {
    this.accessService.resetLogoutTimer();
    let img = this.imagesArray[imageIndex].img;
    //console.log(img);
    const modal = await this.modalCtrl.create({
      component: ImageModalPage,
      cssClass: 'transparent-modal',
      componentProps: {
        img
      }
    });
    modal.present();
  }

  
}
